import model from '../models-v2/bookkeeping/zus-declarations-package';
import beforeZusEnterMiddleware from '../router/beforeZusEnterMiddleware';

export default [
  {
    path: '/zus/packages',
    name: 'zus-declarations-packages',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'ZUS', url: '/zus/packages' },
        { title: 'Zestawy', url: '/zus/packages' },
      ],
      rule: 'editor',
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
    beforeEnter: beforeZusEnterMiddleware,
  },
  {
    path: '/zus/packages/add',
    name: 'zus-declarations-packages-add',
    component: () => import('../views/pages/declarations/zus/ZusPackageAddForm.vue'),
    meta: {
      breadcrumb: [
        { title: 'ZUS', url: '/zus/packages' },
        { title: 'Zestawy', url: '/zus/packages' },
      ],
      rule: 'editor',
      search: false,
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
    beforeEnter: beforeZusEnterMiddleware,
  },
];
